import { fetchApi } from '@/config/axiosSetting';
import { SignatureQueryParamsType } from '@/modules/adjusterReportModules/types/signatureQueryParams.type';

export const patchPropertyDamagedSignatureQueryFunction = (
  params: SignatureQueryParamsType,
): Promise<{}> => {
  return fetchApi({
    method: 'patch',
    url: `/property/reports/${params.id}/accident_users/damaged/images/signature/`,
    data: params.data,
    params: { damaged_id: params.damagedId },
  });
};
